import {UndoRedoState} from '.'
import {Action} from './actions'
import {reducer as flowReducer} from './reducer'

export const undoRedoFlowReducer = (reducer: typeof flowReducer) => {
  return (state: UndoRedoState, action: Action) => {
    const {past, present, future} = state

    if ('type' in action) {
      switch (action.type) {
        case 'undo': {
          if (!past.length) return state // there is no past, remain same state
          const previous = past[past.length - 1]
          const newPast = past.slice(0, past.length - 1)
          return {
            past: newPast,
            present: previous,
            future: [present, ...future]
          }
        }
        case 'redo': {
          if (!future.length) return state // there is no future, remain same state
          const next = future[0]
          const newFuture = future.slice(1)
          return {
            past: [...past, present],
            present: next,
            future: newFuture
          }
        }
        case 'reset-state': {
          return {
            past: [], // reset past
            present: action.data,
            future: [] // reset future
          }
        }
      }
    }
    // delegate to the wrapped reducer
    const newPresent = reducer(present, action)
    if (present === newPresent) {
      return state
    }
    return {
      past: [...past, present],
      present: newPresent,
      future: []
    }
  }
}
